// import { selectRoomState } from "@100mslive/hms-video-store";
// import { HMSPrebuilt } from "@100mslive/roomkit-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  HMSNotificationTypes,
  selectIsConnectedToRoom,
  useHMSActions,
  useHMSNotifications,
  useHMSStore,
} from "@100mslive/react-sdk";
import Conference from "@/components/videoCalling/Conference";
import Footer from "@/components/videoCalling/Footer";
import FullPageProgress from "@/components/videoCalling/FullPageProgress";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsLoggedIn,
  getUserInfo,
  setCurrentForm,
  setFormProps,
  setModalOpen,
} from "@/reducers/commonSlice";
import { getRoomStatusById } from "@/services/common/getRoomStatusById";
import { startStopwatch } from "@/helpers";
import "@/styles/session/callUI.scss";
import { updateRoomStatusById } from "@/services/users/updateRoomStatus";
import { Flex, Popover } from "antd";

import { showNotification } from "@/components/toaster/Toaster";
import socket from "@/socket";
export default function CallUI() {
  const { id: bookingId, roomCode } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  const hmsActions = useHMSActions();
  const notification = useHMSNotifications();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const [localPeerId, setLocalPeerId] = useState("");
  const [hostIds, setHostIds] = useState([]);
  const [callEnded, setCallEnded] = useState(false);
  // const [roomCode, setRoomCode] = useState('')
  const [time, setTime] = useState("00:00");
  // console.log(localPeerId, hostIds);
  useEffect(() => {
    if (notification?.type == HMSNotificationTypes?.ROOM_ENDED) {
      if (notification?.data.roomEnded) {
        if (isLoggedIn) {
          navigate(`/callend/?sid=${bookingId}`);
        } else {
          navigate("/");
        }
      }
    }
  }, [notification]);

  const userInfo = useSelector(getUserInfo);
  const handleJoinRoom = async () => {
    await hmsActions
      .getAuthTokenByRoomCode({ roomCode })
      .then(async (res) => {
        try {
          await hmsActions.join({
            userName: userInfo?.user?.firstName,
            authToken: res,
          });
        } catch (e) {
          console.error(e);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (roomCode) {
      setTimeout(() => {
        handleJoinRoom();
      }, 10000);
    }
  }, [roomCode]);

  const leaveRoom = () => {
    hmsActions.leave();
  };

  useEffect(() => {
    let isUserLeaving = false;

    // Custom handler to show the confirmation modal
    const showCustomPopup = async () => {
      dispatch(setCurrentForm("confirmDelete"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          onSubmit: () => {
            isUserLeaving = true;
            leaveRoom();
            dispatch(setModalOpen(false));
          },
          message: "Are you sure you want to end this call?",
        })
      );

      // Wait for user interaction with the modal
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          // Check if the user confirmed the action (modal closed and navigation proceeded)
          if (isUserLeaving) {
            clearInterval(interval);
            resolve(true);
          }
        }, 100);
      });
    };

    // Handle beforeunload (refresh/close tab)
    const handleBeforeUnload = async (event) => {
      if (!isUserLeaving) {
        event.preventDefault();
        event.returnValue = ""; // Prevent the browser popup
        return "";
      }
    };

    // Handle link clicks and form submissions
    const handleNavigation = async (event) => {
      // Ignore clicks inside the toast notification
      if (event.target.closest(".ant-notification-notice")) {
        return; // Do nothing when clicking the toast close button
      }

      if (
        !isUserLeaving &&
        event.target.closest("a, form") &&
        !event.target.closest(".report-form")
      ) {
        // Added exclusion for report form
        event.preventDefault();

        try {
          const shouldLeave = await showCustomPopup();
          if (shouldLeave) {
            leaveRoom();
            const href =
              event.target.closest("a")?.href || event.target.closest("form")?.action || ""; // Get form action if no <a>
            isUserLeaving = true;
            window.location.href = href;
          }
        } catch (error) {
          console.error("Error during navigation:", error);
        }
      }
    };

    // Handle back/forward button (history navigation)
    const handlePopState = async (event) => {
      if (!isUserLeaving) {
        event.preventDefault();
        const shouldLeave = await showCustomPopup();
        if (!shouldLeave) {
          window.history.pushState(null, "", window.location.href); // Prevent navigation
        }
      }
    };
    const handleGraceTimeApproval = () => {
      showNotification("success", "Approved!", "The host has approved your grace time request.");
      fetchRoomDetails();
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("click", handleNavigation, true);
    window.addEventListener("popstate", handlePopState);
    window.addEventListener("graceTimeApproval", handleGraceTimeApproval);

    // Cleanup event listeners
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("click", handleNavigation, true);
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("graceTimeApproval", handleGraceTimeApproval);
    };
  }, [hmsActions, isConnected, navigate, dispatch]);

  // const executeTask = () => {
  //     startStopwatch(responseData, (formattedTime) => {
  //       console.log(formattedTime)
  //       setTime(formattedTime);
  //   })
  // }

  const isGuest = window.location.pathname?.includes("guest");

  const fetchRoomDetails = () => {
    console.log("CallUI: Fetching room details for bookingId:", bookingId);
    getRoomStatusById(bookingId, isGuest ? "guest" : "normal")
      .then((res) => {
        console.log("CallUI: Room details response:", res);
        if (!res.enabled) {
          leaveRoom();
          if (isLoggedIn) {
            navigate(`/callend/?sid=${bookingId}`);
          } else {
            navigate("/");
          }
          return;
        }
        if (!res.sessionStartTime) {
          console.log("CallUI: No session start time, retrying...");
          setTimeout(() => {
            fetchRoomDetails();
          }, 1000);
          return;
        }
  
        // Compute maxDuration for stopwatch usage
        const maxDuration = res.duration + (res.graceTime || 0); 
  
        console.log("CallUI: Starting stopwatch with duration:", maxDuration);
  
        // Reset the stopwatch with new duration
        startStopwatch({ ...res, maxDuration }, (formattedTime) => {
          console.log("CallUI: Stopwatch update:", formattedTime);
          if (formattedTime === "00:00") {
            if (hostIds.includes(localPeerId)) {
              updateRoomStatusById(bookingId, {
                enable: false,
              })
                .then((res) => {
                  console.log("CallUI: Room status updated:", res);
                  leaveRoom();
                })
                .catch((err) =>
                  console.error("CallUI: Error updating room status:", err)
                );
            }
            if (isLoggedIn) {
              navigate(`/callend/?sid=${bookingId}`);
            } else {
              navigate("/");
            }
          }
          setTime(formattedTime);
        });
      })
      .catch((err) => {
        console.error("CallUI: Error fetching room details:", err);
      });
  };
  

  useEffect(() => {
    let timeoutId;

    const fetchDetails = () => {
      if (!callEnded) {
        // Only fetch if the call is not ended
        timeoutId = setTimeout(() => {
          fetchRoomDetails();
        }, 5000);
      }
    };

    fetchDetails();

    return () => {
      clearTimeout(timeoutId); // Cleanup timeout when component unmounts or dependency changes
    };
  }, [bookingId, callEnded]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("CallUI: Joining socket with token:", token);
    socket.emit("joinSocket", { token });

    const handleGraceTimeUpdate = (event) => {
      console.log("CallUI: Received grace time update event:", event.detail);
      // Force immediate time update regardless of role
      if (event.detail.forceUpdate) {
        console.log("CallUI: Forcing immediate time update");
        fetchRoomDetails();
      }
    };

    socket.on("onUpdateDuration", (data) => {
      console.log("CallUI: Received duration update:", data);
      if (data.isApproved) {
        // Force immediate time update for both mentor and student
        console.log("CallUI: Grace time approved, updating time");
        fetchRoomDetails();
      }
    });

    socket.on("forceTimeUpdate", (data) => {
      console.log("CallUI: Received force time update:", data);
      // Force immediate time update for both mentor and student
      console.log("CallUI: Forcing time update from socket");
      fetchRoomDetails();
    });

    window.addEventListener("graceTimeUpdated", handleGraceTimeUpdate);

    return () => {
      socket.off("onUpdateDuration");
      socket.off("forceTimeUpdate");
      window.removeEventListener("graceTimeUpdated", handleGraceTimeUpdate);
    };
  }, []);

  // Add periodic room details refresh
  useEffect(() => {
    const interval = setInterval(() => {
      fetchRoomDetails();
    }, 30000); // Refresh every 30 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ paddingTop: "10px" }}>
      {isConnected ? (
        <>
          <Flex align="center" style={{ padding: "10px" }}>
            <Flex flex={1} align="center" justify="center" gap={"0.5rem"}>
              <span>Time Left:</span>
              <span className="time-chip">{time}</span>
            </Flex>
            <div style={{ width: "40px", height: "40px" }} className="cursor-pointer">
              <Popover
                placement="rightBottom"
                content={<div>"This session is being recorded."</div>}
                onClick={(e) => e.stopPropagation()}
              >
                <img src="/assets/images/recording.png" height={"100%"} width={"100%"} />
              </Popover>
            </div>
          </Flex>
          <Conference
            setLocalPeerId={setLocalPeerId}
            setHostIds={setHostIds}
            fetchRoomDetails={fetchRoomDetails}
          />
          <Footer
            isHost={hostIds.includes(localPeerId)}
            bookingId={bookingId}
            setCallEnded={setCallEnded}
          />
        </>
      ) : (
        <FullPageProgress />
      )}
    </div>
  );
}
